<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Mehinaku</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="noindent"><a id="page_31"></a>(On following page). Constellations: the jaguar, the tapir and the anteater. “In the night sky,” say the villagers, “there is a jaguar and his prey, the tapir and the anteater.” But try as I might, I could never make the stars resemble Kuyaparei’s watercolor. At last I came to understand that the Mehinaku view of the sky is different from ours. Rather than connecting the stars with imaginary lines to form shapes, they see shapes in the spaces between the stars, for from Antares to beyond Altair a band of blackness blots out the tropical night sky. Outlined by the glow of the Milky Way, these black spaces form some of the villagers’ major constellations.</p>
<p class="normal">In the illustration Kuyaparei’s many-toed tapir (a relative of the horse having three- or four-part hoofs) appears on the left, while the jaguar looms over the anteater on the right.</p>
<div class="pagebreak">
<h2 class="head" id="pa_2"><a id="page_32"></a><a href="#/xhtml/Contents#pa2"><span class="head01">2</span></a> The Setting for the Drama</h2>
<p class="image"><img alt="" height="317" src="images/page_32.jpg" width="381"/></p>
<p class="noindent"><a id="page_33"></a>The Mehinaku village and its environs are a theater for the enactment of everyday social relationships. Like all theaters, the community has spatial and physical properties that both reflect and affect the course of the performance. Thus the layout of the village and the architecture of the houses are simultaneously a spatial representation of Mehinaku social organization and a traffic pattern for the flow of information and interaction.</p>
<p class="normal">The chapters that follow examine the dramaturgical characteristics of the Mehinaku village-theater. We have noted that it is a theater with splendid acoustics and few obstructed seats. In fact, the visibility and audibility of social action and the efficiency of the institutions that broadcast information create special problems. Managing everyday social activities, from children’s games to extramarital sex, requires the villagers to become masters of information control and stagecraft. I begin the discussion of the village as a theater with an introduction to Mehinaku space, settings, and designs.<a id="page_34"></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part2.vue?17531190